export const getGlobalMessages = ({ globalMessages: { messages } }) => messages
